angular.module('services')
  .constant('_', window._)
  .constant('moment', window.moment)
  .constant('Tether', window.Tether)
